<template>
  <!-- A lesson-request ghost opens its card. A teacher's own ghost (useRequestGhosts.js) opens
       their Signups-tab card: confirm / suggest / decline. An admin calendar ghost
       (/admin/calendar-request-ghosts, signup = {inquiry_id, contact_id}) opens the admin SignupCard. -->
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" @click.self="emit('close')">
    <div class="w-full max-w-md max-h-[90vh] overflow-y-auto">
      <div class="flex justify-end mb-1.5">
        <button class="rounded-full p-1 bg-surface dark:bg-surface-raised-dark text-fg-secondary dark:text-fg-secondary-dark shadow" @click="emit('close')" title="Close">
          <XMarkIcon class="h-4 w-4" />
        </button>
      </div>
      <template v-if="signup.inquiry_id">
        <SignupCard v-if="inquiry" :inquiry="inquiry" is-admin @updated="emit('updated')" />
        <div v-else class="card text-sm text-fg-muted dark:text-fg-muted-dark">{{ loadError || 'Loading…' }}</div>
      </template>
      <TeacherSignupCard v-else :signup="signup" @updated="emit('updated')" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import TeacherSignupCard from '@/components/common/TeacherSignupCard.vue'
import SignupCard from '@/components/common/SignupCard.vue'
import { useApi } from '@/composables/useApi.js'

const props = defineProps({ signup: { type: Object, required: true } })
const emit = defineEmits(['close', 'updated'])

const { fetchApi } = useApi()
const inquiry = ref(null)
const loadError = ref(null)
if (props.signup.inquiry_id) {
  fetchApi(`/api/admin/submissions?contact_id=${props.signup.contact_id}`)
    .then(rows => {
      inquiry.value = rows.find(r => r.id === props.signup.inquiry_id) || null
      if (!inquiry.value) loadError.value = 'This signup is no longer open.'
    })
    .catch(() => { loadError.value = 'Could not load this signup.' })
}
</script>
